<template>
  <div id="caseBlanche"  >
    <img :src="path+'static/images/loading.png'" id="rond1" class="rond">
    <div id="load" flex="main:center cross:center">
      <p style="margin: auto">{{percent}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "v-loading",
    props: {
      top: {
        type: [String, Number],
        default: '0'
      }
    },
    data(){
      return {
        percent:'0%'
      }
    },
    components:{
    },
    methods:{
      setPercent(value){
        this.percent = value;
      }
    },
    computed: {
      styleObj() {
        return {
          marginTop: (typeof this.top === 'string') ? this.top : this.top + 'px'
        }
      }
    },
    mounted(){
    }
  }
</script>

<style scoped lang="scss">
  #caseBlanche {
    height: 72px;
    width: 72px;
    float: left;
    z-index: 1;
  }

  @media screen and (max-width: 1367px){
    #caseBlanche {
      height: 60px !important;
      width: 60px !important;
      p{
        height: 60px !important;
        line-height: 60px !important;
      }
    }
  }
  .rond {
    height  : 100%;
    width : 100%;
  }
  #rond1{
    -webkit-animation : rond1 1.2s infinite;
    animation : rond1 1.2s infinite;
    opacity:1;
  }
  #load{
    color:#000 !important;
  }
  @keyframes rond1 {
    0% {transform : rotate(360deg);-webkit-transform:rotate(360deg);transition-duration: .2s}
    100% {-webkit-transform : rotate(0deg);transform : rotate(0deg);}
  }
  #caseBlanche #load {
    color : #fff;
    font-family :PingFangSC-Light,Microsoft Yahei,sans-serif;
    text-align : center;
    position : absolute;
    width:100%;
    height:100%;
    top: 0;
  }
  #caseBlanche p {
    display: block;
    font-weight: bold;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    margin: auto;
    height: 72px;
    line-height: 72px;
    width: 100%;
  }
</style>
